import { API as ThreadsOfSuccessV2Service } from '@weave/schema-gen-ts/dist/schemas/threads-of-success/v2/api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaThreadsOfSuccessServiceV2 = bindHTTP(ThreadsOfSuccessV2Service);
